<template>
    <div>
        <div class="d-flex flex-wrap">
        <div v-for="quickAccess in quickAccessList" :key="quickAccess.name">
                <quick-access-list-item :quickAccessData="quickAccess" />
        </div>
        </div>
        <v-row>
            <v-col cols="12" sm="6" md="6" lg="4" xl="3">
                <quick-access-list-item @addQuickAccess="openQuickAccessRegister" />
            </v-col>
        </v-row>
        <quick-access-register
            v-if="dialogs.showQuickAccessRegister"
         :showDialog="dialogs.showQuickAccessRegister"
            @goBack="dialogs.showQuickAccessRegister = false"/>       
    </div>
</template>

<script>
import QuickAccessListItem from './QuickAccessListItem.vue'
import {mapGetters} from 'vuex'

export default {
  data: () => {
      return {
          dialogs:{
              showQuickAccessRegister: false,
          }
      }
  },
  components: { QuickAccessListItem,
    QuickAccessRegister: () => import('@/components/unique/home/QuickAccessRegister') },
  computed:{
      ...mapGetters({quickAccessList: 'systemModule/getQuickAccessList'})
  },
  methods:{
      openQuickAccessRegister(){
          this.dialogs.showQuickAccessRegister = true
      }
  }
}
</script>

<style>

</style>